// extracted by mini-css-extract-plugin
export default {"cell":"tableSkeleton_cell__3bNFy","skeleton":"tableSkeleton_skeleton__F9ahL","shimmer":"tableSkeleton_shimmer__2ylVh","hideMobile":"tableSkeleton_hideMobile__86dlG"};